export default "__VITE_ASSET__CTaDiE4N__"